// extracted by mini-css-extract-plugin
export default {"H5Component":"index_H5Component__GH6T9"};